//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            showNext: false,
            showHint: false,
            result: {},
            numFound: 0,
            clickAreas: [
                {
                    x: 145,
                    y: 470,
                    scale: 0.7
                },
                {
                    x: 270,
                    y: 410,
                    scale: 0.7
                },
                {
                    x: 460,
                    y: 610,
                    scale: 0.9
                },
                {
                    x: 680,
                    y: 450,
                    scale: 0.8
                },
                {
                    x: 1070,
                    y: 360,
                    scale: 0.9
                }
            ]
        };
    }
};
